export class GetQueueRequest{
    public listIdStatusQueue: number[] = [];
    public listIdEpisode: number[] = [];

    public idService: number | null = null;
    public idSector: number | null = null;
    public idRoom: number | null = null;    
    public pageIndex: number = 0;
    public idModule: number | null = null;
}